export default class Mask {
  constructor(mask, { ariaLabel, inputType, maskChar, placeholder } = {}) {
    this.ariaLabel = ariaLabel
    this.inputType = inputType
    this.maskChar = maskChar
    this.mask = mask
    this.placeholder = placeholder
  }
}
